/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown> }} Idea_Min_LengthInputs */

const en_idea_min_length = /** @type {(inputs: Idea_Min_LengthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Write at least ${i?.min} characters`)
};

const id_idea_min_length = /** @type {(inputs: Idea_Min_LengthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tulis minimal ${i?.min} karakter`)
};

/**
* | output |
* | --- |
* | "Write at least {min} characters" |
*
* @param {Idea_Min_LengthInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_min_length = /** @type {((inputs: Idea_Min_LengthInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_Min_LengthInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_min_length(inputs)
	return en_idea_min_length(inputs)
});